import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReceiptStatisticsAllRequest } from 'store/organisation/actions';
import {
  getReceiptStatisticsAll,
  getReceiptStatisticsDateRangeKey,
  getReceiptStatisticsLoading,
} from 'store/organisation/selectors';
import { ReceiptStatisticsDateRange } from 'store/organisation/models';
import { receiptStatisticsDateRangeKey } from 'utils/receipt-statistics';

export const useReceiptStatisticsAll = (
  dateRange: ReceiptStatisticsDateRange = {},
  enabled = true
) => {
  const dispatch = useDispatch();
  const statistics = useSelector(getReceiptStatisticsAll);
  const loading = useSelector(getReceiptStatisticsLoading);
  const cachedDateRangeKey = useSelector(getReceiptStatisticsDateRangeKey);
  const requestedKey = receiptStatisticsDateRangeKey(dateRange);

  useEffect(() => {
    if (!enabled) return;
    if (!statistics || cachedDateRangeKey !== requestedKey) {
      dispatch(fetchReceiptStatisticsAllRequest(dateRange));
    }
  }, [
    dispatch,
    enabled,
    statistics,
    cachedDateRangeKey,
    requestedKey,
    dateRange.from,
    dateRange.to,
  ]);

  return {
    statistics,
    loading,
    isCached: Boolean(statistics) && cachedDateRangeKey === requestedKey,
  };
};
